import { Spinner } from "./Spinner.Style";

export default Spinner;